import React, { Component } from 'react';

class RelatedProduct extends Component {
	render() {
		return (
			<section className="related__products">
				<div className="container-fluid">
					<h1 className="related__products__title">There’s <em>more</em> where <br /> this came from</h1>
					<div className="row">
						<div className="col-md-6">
							<img className="img-fluid" src="/images/related-product/product-1.png" />
							<h1 className="related__products__subtitle">Light Years: Anti-Ageing Duo</h1>
							<p className="related__products__info">Serum 15ml + Night Cream 30 ml   |  $25.00</p>
							<button className="related__products__btn btn btn-outline-primary">Shop Now  |  $25</button>
						</div>
						<div className="col-md-6 mt-4 mt-sm-0">
							<img className="img-fluid" src="/images/related-product/product-2.png" />
							<h1 className="related__products__subtitle">Personalised Night Cream</h1>
							<p className="related__products__info">Nutri-Repair Night Cream 30ml  |  $25.00</p>
							<button className="related__products__btn btn btn-outline-primary">Shop Now  |  $25</button>
						</div>

					</div>
				</div>
			</section>
		);
	}
}


export default RelatedProduct;